type ClientType = "SHOPPER" | "PROVIDER";

export const client = {
  OPENBASS: process.env.NEXT_PUBLIC_OPENBAAS ?? "",
  API: process.env.NEXT_PUBLIC_API ?? "",
  GOOGLE: process.env.NEXT_PUBLIC_GOOGLE ?? "",
  TYPE: (process.env.NEXT_PUBLIC_TYPE as ClientType) ?? "",
};
